/**
 * @link https://mui.com/material-ui/react-accordion/
 */

import * as React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography, Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeAccordion() {
  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Accordion 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography variant="body2">Accordion 2</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography variant="body2">Disabled Accordion</Typography>
        </AccordionSummary>
      </Accordion>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Accordion color weight levels (elevation)</Typography></Divider>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Level 0 (Default)</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          variant="level1"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Level 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
            <AccordionSummary
              variant="level2"
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography variant="body2">Level 2</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                malesuada lacus ex, sit amet blandit leo lobortis eget.
              </Typography>
            </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="level3"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography variant="body2">Level 3</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="level4"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography variant="body2">Level 4</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Accordion Variants (Color mark for Facturee OP Units)</Typography></Divider>

      <Accordion>
        <AccordionSummary
          variant="sales"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Sales</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="purchase"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Purchase</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="accounting"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Accounting</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="qm"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Quality Management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="packaging"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Packaging</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          variant="logistics"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Logistics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`function AccordionExample() {
  return (
    <>
      {/* Basic Accordions */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body2">Accordion 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            malesuada lacus ex, sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
      </Accordion>
      
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography variant="body2">Disabled Accordion</Typography>
        </AccordionSummary>
      </Accordion>

      {/* Accordion with Elevation Levels */}
      <Divider textAlign="left">
        <Typography variant="h6">Accordion Elevation Levels</Typography>
      </Divider>
      
      <Accordion>
        <AccordionSummary
          variant="level1"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="level1-content"
          id="level1-header"
        >
          <Typography variant="body2">Level 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Content for level 1 accordion.
          </Typography>
        </AccordionDetails>
      </Accordion>
      
      <Accordion>
        <AccordionSummary
          variant="level2"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="level2-content"
          id="level2-header"
        >
          <Typography variant="body2">Level 2</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Content for level 2 accordion.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Facturee Custom Accordions */}
      <Divider textAlign="left">
        <Typography variant="h6">Facturee OP Units</Typography>
      </Divider>
      
      <Accordion>
        <AccordionSummary
          variant="sales"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="sales-content"
          id="sales-header"
        >
          <Typography variant="body2">Sales</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Sales department content.
          </Typography>
        </AccordionDetails>
      </Accordion>
      
      <Accordion>
        <AccordionSummary
          variant="purchase"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="purchase-content"
          id="purchase-header"
        >
          <Typography variant="body2">Purchase</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Purchase department content.
          </Typography>
        </AccordionDetails>
      </Accordion>
      
      <Accordion>
        <AccordionSummary
          variant="qm"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="qm-content"
          id="qm-header"
        >
          <Typography variant="body2">Quality Management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Quality Management department content.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
}`} 
        scope={{ 
          React, 
          Accordion, 
          AccordionSummary, 
          AccordionDetails, 
          Typography, 
          Divider, 
          ExpandMoreIcon 
        }} 
      />
    </>
  );
}